import { ISourceDataEvent } from "@/api/dtos";
import { useScopedField } from "@ngt/forms-core";
import { useMemo } from "react";
import { ISourceDataVerificationEvent, SourceDataType, ISourceDataVerificationSection, ISourceDataVerificationField } from '../../utilities/forms/SourceDataFormProcessor';

const useSourceDataEventReviewCount = (propertyPath: string, eventInfo: ISourceDataVerificationEvent) => {
    const { state: { value }} = useScopedField<ISourceDataEvent>(propertyPath, { value: true }, false, true);

    const counts = useMemo(() => {
        if (!value) {
            return undefined;
        }

        let total = 0;
        let reviewed = 0;
        let verified = 0;
        let totalToReview = 0;
        let totalToVerify = 0;

        if (value.forms) {
            for (let form of Object.values(value.forms)) {
                const formInfo = eventInfo.forms?.find(x => x.formKey === form.formMetadataId);
                
                if (form.fields) {
                    for (let field of Object.values(form.fields)) 
                    for (let fieldRepeat of Object.values(field)){
                        total++;

                        const fieldInfo = fieldRepeat.formSectionMetadataId ? 
                            (formInfo?.fields?.find(x => x.type === SourceDataType.Section && x.formSectionKey === fieldRepeat.formSectionMetadataId) as ISourceDataVerificationSection)?.fields?.find(x => x.type === SourceDataType.Field && x.formFieldKey === fieldRepeat.formFieldMetadataId) :
                            formInfo?.fields?.find(x => x.type === SourceDataType.Field && x.formFieldKey === fieldRepeat.formFieldMetadataId) as ISourceDataVerificationField

                        if (fieldInfo?.formFieldConfiguration?.allowSourceDataVerification && fieldInfo?.formFieldConfiguration?.allowReview) {
                            totalToReview++;

                            if (fieldRepeat.reviewed) {
                                reviewed++;
                            }
                        }

                        if (fieldInfo?.formFieldConfiguration?.allowSourceDataVerification && fieldInfo?.formFieldConfiguration?.allowVerify) {
                            totalToVerify++;

                            if (fieldRepeat.verified) {
                                verified++;
                            }
                        }
                    }
                }
            }
        }

        if (total > 0) {
            return {
                reviewed,
                verified,
                totalToReview,
                totalToVerify,
                total
            };
        }

        return undefined;
    }, [value])

    return counts;
}

export default useSourceDataEventReviewCount;